import { render } from "./TvmBvConfirmation.vue?vue&type=template&id=7a2ddbbf"
import script from "./TvmBvConfirmation.vue?vue&type=script&lang=js"
export * from "./TvmBvConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/TvmBvConfirmation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a2ddbbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a2ddbbf', __exports__)) {
    api.reload('7a2ddbbf', __exports__)
  }
  
  module.hot.accept("./TvmBvConfirmation.vue?vue&type=template&id=7a2ddbbf", () => {
    api.rerender('7a2ddbbf', render)
  })

}


export default __exports__